import { type FC, PropsWithChildren, useRef } from 'react';
import { createProvider } from '../../../utils/createProvider';
import { ToolNavigationData, ToolNavigationNoData } from '../types';
import { getPageAccessData } from '../utils';
import { NavigationBuilder } from '../../toolNavigationBuilder/navigationBuilder';
import { useNavigationStrategyResolver } from '../../toolNavigationBuilder/strategyResolver';
import { hasToolNavigation } from '../hasToolNavigation';

const [Provider, useProvider] = createProvider<ToolNavigationData | ToolNavigationNoData>({
	contextName: 'ToolNavigationDataRefContext',
	strict: false,
});

export const useToolNavigationDataProvider = useProvider as () => ToolNavigationData;

export const ToolNavigationDataProvider: FC<PropsWithChildren> = ({ children }) => {
	const dataRef = useRef<ToolNavigationData | ToolNavigationNoData>();
	const navigationStrategy = useNavigationStrategyResolver();

	if (hasToolNavigation()) {
		const { pageTypeIds } = getPageAccessData();

		const navigationBuilder = new NavigationBuilder(navigationStrategy);
		dataRef.current = navigationBuilder.build(pageTypeIds);
	} else {
		dataRef.current = {
			hasToolNavigation: false,
		};
	}

	return <Provider value={dataRef.current}>{children}</Provider>;
};
